import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TabsetComponent } from 'ngx-bootstrap';
import { CacheService } from '../../../shared/services/cache.service';
import { MessageService } from '../../../shared/services/message.service';
import { TabConstants } from '../../constants/tab.constants';
import { OrderInfoTab } from '../../models/order-info-tab-model';
import { CacheKey } from '../../../shared/constants/cachekey.constants';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'pos-order-tabs',
    templateUrl: '../../templates/template1/views/pos-orders/pos-order-tabs.component.html',
    styleUrls: ['../../templates/template1/themes/default/less/orders.component.less'],
})
export class PosOrderTabsComponent implements OnInit {
    activeTab: number;
    isEditOrders: boolean;
    webOrderId: string;
    updatedOrderInfo:any;
    orderHistoryTabs: OrderInfoTab[] = new Array<OrderInfoTab>();
    @ViewChild('orderTabs') orderTabs: TabsetComponent;

    constructor(private messageService: MessageService, private activatedRoute: ActivatedRoute, private _cacheService: CacheService,
        private _translatePipe: TranslateService) {}

    ngOnInit() {
        this._cacheService.remove(CacheKey.PaymentInstrumentId);
        this.activatedRoute.params.subscribe((params: Params) => {
            this.webOrderId = params['webOrderId'];
        });
        this.updatedOrderInfo = this._cacheService.get('UpdatedOrderInfo');
        this._cacheService.remove('UpdatedOrderInfo');
        if (this.webOrderId) {
            this.activeTab = 2;
            this.isEditOrders = true;
        } else if (this.updatedOrderInfo && this.updatedOrderInfo.webOrderId && this.updatedOrderInfo.countryCode){
            let orderInfo = new OrderInfoTab();
            orderInfo.webOrderID = this.updatedOrderInfo.webOrderId;
            orderInfo.tabForOrderPromotion = true;
            orderInfo.homeCountry = this.updatedOrderInfo.countryCode;
            this.addOrderTab(orderInfo);
        } else {
            this.activeTab = 1;
        }
        this.subscribeOrderHistoryTab();

    }
    
    /**
     * @description
     * @date 2020-03-05
     * @param {OrderInfoTab} data
     * @memberof OrderTabsComponent
     */
    addOrderTab(data: OrderInfoTab){
        if (data.emailID) {
            data.componentName = 'orderViewTab';
            const title: any = this._translatePipe.get('order.Account Confirmation');
            data.title = title.value;
            data.recentOrder = true;
            data.active = true;
            this.activeTab = 0;
            data.disabled = false;
            data.removable = true;
            this.orderHistoryTabs.push(data);
        } else {
            data.componentName = 'orderViewTab';
            data.title = 'Order - ' + data.webOrderID;
            data.recentOrder = true;
            data.active = true;
            this.activeTab = 0;
            data.disabled = false;
            data.removable = true;
            this.orderHistoryTabs.push(data);
        }
    }

    /**
     * @description
     * @date 2020-03-05
     * @memberof OrderTabsComponent
     */
    subscribeOrderHistoryTab() {
        this.messageService.getOrderHistoryTab().subscribe((data: OrderInfoTab) => {
            if (data && data.tabForOrderPromotion) {
                this.addOrderTab(data);
            }
        });
    }

    /**
     * @description
     * @date 2020-03-03
     * @param {*} tab
     * @memberof OrderTabsComponent
     */
    removeOrderTab(tab: any): void {
        if (this.orderHistoryTabs) {
            this.orderHistoryTabs.splice(this.orderHistoryTabs.indexOf(tab), 1);
            const tabIndex = this.orderTabs.tabs.findIndex(item => item.id === TabConstants.ORDER_PROMOTION);
            this.orderTabs.tabs[tabIndex].active = true;
            this.activeTab = 1;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/pos-orders/pos-order-tab.component.ts